export default __webpack_public_path__ + "static/media/1307.5c89f8d2.png";